import { createApp } from "vue";
import App from "@/App.vue";
import store from "@/store";
import router from "@/router";
import { createI18n } from "vue-i18n";
import it from "@/locales/it.json";
import en from "@/locales/en.json";
import detectMobile from "@/plugins/mobile-detection";
import QrCode from "spid-wc-passwordless-infocert";
import "./version.js";

import { loadConfig } from "./config.js";
import { setConfig } from "./configStore";

function getLang() {
  let uri = window.location.search.substring(1);
  let params = new URLSearchParams(uri);
  let param = params.get("lang");
  return param || "it";
}

const i18n = createI18n({
  legacy: false,
  messages: {
    it,
    en
  },
  locale: getLang(),
  fallbackLocale: "it"
});

loadConfig().then((config) => {
  setConfig(config);
  const mountEl = document.querySelector("#app");

  const app = createApp(App, { ...mountEl.dataset });

  app.config.globalProperties.$env = config;

  app
    .use(store)
    .use(router)
    .use(i18n)
    .use(detectMobile)
    .use(QrCode)
    .mount("#app");

}).catch(err => {
  console.error("Errore durante il caricamento della config:", err);
});
